<h1 mat-dialog-title>Review Output Files</h1>
<mat-dialog-content>
  @if (entries.length === 0) {
    <p class="empty">No files to preview for the selected products and formulas.</p>
  }
  @if (entries.length > 0) {
    <table mat-table [dataSource]="entries" class="files-table">
      <ng-container matColumnDef="filename">
        <th mat-header-cell *matHeaderCellDef>Filename</th>
        <td mat-cell *matCellDef="let entry" class="filename">{{ entry.filename.generated }}</td>
      </ng-container>
      <ng-container matColumnDef="hasFile">
        <th mat-header-cell *matHeaderCellDef>Has File</th>
        <td mat-cell *matCellDef="let entry">
          @if (hasFile(entry)) {
            <mat-icon class="present-icon">check_circle</mat-icon>
          }
          @if (!hasFile(entry)) {
            <mat-icon class="missing-icon">cancel</mat-icon>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="reviewState">
        <th mat-header-cell *matHeaderCellDef>Review State</th>
        <td mat-cell *matCellDef="let entry">{{ reviewStateLabel(entry) }}</td>
      </ng-container>
      <ng-container matColumnDef="released">
        <th mat-header-cell *matHeaderCellDef>Released</th>
        <td mat-cell *matCellDef="let entry">{{ releasedLabel(entry) }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
